import { Alert, Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
export const MAX_EVENTS = 2000;
export default function EventsWarning() {
  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Alert
        icon={
          <Box
            sx={{
              backgroundColor: "#fff3cd",
              borderRadius: "50%",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "0.9em",
            }}
          >
            <WarningAmberIcon sx={{ color: "#ff9800", fontSize: 20 }} />
          </Box>
        }
        severity="warning"
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: 2,
          px: 1,
          py: 0,
          fontSize: "0.8em",
          alignItems: "center",
          boxShadow: 1,
          border: "1px solid #ffeeba",
          fontStyle: "italic",
        }}
      >
        Você carregou mais de <b>{MAX_EVENTS} eventos</b>. Nesse caso, apenas a
        opção de enquadramento por biblioteca estará disponível.
      </Alert>
    </Box>
  );
}
